var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 22,
    viewBox: "0 0 14 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13348",
    "data-name": "Path 13348",
    d: "M171.605,267l2.508,1.759-1.534,1.809a5.193,5.193,0,0,1,1.45,3.776,4.986,4.986,0,0,1-2.9,4.755,4.286,4.286,0,0,1,2.844,4.214c0,3.516-2.9,5.688-6.886,5.688s-6.972-2.251-6.972-5.692h3.375c0,1.655,1.644,2.743,3.6,2.743s3.486-.981,3.486-2.743-1.784-2.559-3.486-2.559c-4.3,0-6.973-2.429-6.973-6.41s3.124-6.465,6.973-6.465a5.815,5.815,0,0,1,3.15.724Zm-8.115,7.344a3.583,3.583,0,0,0,7.166,0,3.583,3.583,0,1,0-7.166,0",
    transform: "translate(-160.113 -267)",
    fill: "#3b293f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGBlack);
export default __webpack_public_path__ + "static/media/gBlack.065b79e5df65a36f20c7066dc59391ed.svg";
export { ForwardRef as ReactComponent };